import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styles from './Avatar.module.css';
export const Avatar = ({ type = 'inicial', size = 'medium', initials = 'TR', src, alt, className, focus = false, style, ...props }) => {
    const displayInitials = initials?.slice(0, 2).toUpperCase() || 'TR';
    const sizeClasses = {
        small: styles.avatarSmall,
        medium: styles.avatarMedium,
        large: styles.avatarLarge,
    };
    const combinedClassName = [styles.avatar, sizeClasses[size], focus && styles.avatarFocused, className]
        .filter(Boolean)
        .join(' ');
    return (_jsx("div", { className: combinedClassName, style: style, "data-testid": 'avatar-container', ...props, children: type === 'image' && src ? (_jsx("img", { src: src, alt: alt || 'Avatar', className: styles.avatarImage, "data-testid": 'avatar-image' })) : (_jsx("span", { "data-testid": 'avatar-initials', children: displayInitials })) }));
};
export default Avatar;
